export default {
  zh: {
    timeR: '倒计时: ',
    ruleText: '规则',
    DailyBenefits: '每日福利',
    rule: '1. Daily rewards: When  participants recharge reach a specific amount, participants must manually click the "Get" button in order to receive the extra coins.<br/>2. Monthly rewards: When participants recharge reaches that specific amount, participants must manually click the "GET" button to receive the entire package gift.<br/>3. Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>4. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>5. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>6. After obtaining the Recharge Stars for 3 consecutive time, you will have it permanently.<br/>7. App has the final right of this activity . ',
    monthly: '每月福利',
    get: 'Get',
    headwear: 'Headwear',
    service: 'To get your ID after you done recharge contact customer service',
    rule: `
    1. Daily rewards: When  participants recharge reach a specific amount, participants must manually click the "Get" button in order to receive the extra coins.<br/>
    2. Monthly rewards: When participants recharge reaches that specific amount, participants must manually click the "GET" button to receive the entire package gift.<br/>
    3. Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    4. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    5. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    6. After obtaining the Recharge Stars for 3 consecutive time, you will have it permanently.<br/>
    7. App has the final right of this activity . <br/><br/>
    - Monthly recharge ID upgrade rules <br/>
    1. The monthly time is Saudi time from the 1st of each month to the 1st of next month. <br/>
    2. ID can not be transfer to other accounts. <br/>
    3. Every ID can set one time a month through the monthly recharge. <br/>
    4. Each account can only get one ID per monthl through monthly recharge. <br/>
    5. To more details contact ID 1. <br/>
    `,
    dayText: 'Gün',
  },
  en: {
    timeR: 'Count down: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    rule: `
    1. Daily rewards: When  participants recharge reach a specific amount, participants must manually click the "Get" button in order to receive the extra coins.<br/>
    2. Monthly rewards: When participants recharge reaches that specific amount, participants must manually click the "GET" button to receive the entire package gift.<br/>
    3. Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    4. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    5. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    6. After obtaining the Recharge Stars for 3 consecutive time, you will have it permanently.<br/>
    7. App has the final right of this activity . <br/><br/>
    - Monthly recharge ID upgrade rules <br/>
    1. The monthly time is Saudi time from the 1st of each month to the 1st of next month. <br/>
    2. ID can not be transfer to other accounts. <br/>
    3. Every ID can set one time a month through the monthly recharge. <br/>
    4. Each account can only get one ID per monthl through monthly recharge. <br/>
    5. To more details contact ID 1. <br/>
    `,
    monthly: 'Monthly Benefits',
    get: 'Get',
    headwear: 'Headwear',
    service: 'To get your ID after you done recharge contact ID 2',
    tipText: 'This recharge activity has ended.',
    dayText: 'days',
  },
  ar: {
    timeR: 'العد التنازلي',
    ruleText: 'قواعد',
    DailyBenefits: 'المكافأت اليومية',
    rule: `
    1. المكافأة اليومية: عندما يقوم المشاركون بإعادة شحن مبلغ محدد ، يجب على المشاركين النقر يدويًا إلى زر "Get" للحصول على عملات  إضافية
    <br/>2.المكافآت الشهرية: عندما يصل المشاركون إلى هذا المبلغ المحدد ، يجب على المشاركين النقر يدويًا إلى زر "GET" لتلقي هدية حزمة بأكملها
    <br/>3. أفعال لا يطالب بها أحد ، سيفقد المشاركون جوائزهم إذا فشلوا في استرداد جوائزهم. لن تكون App مسؤولة عن أي هدايا مفقودة
    <br/>4. للمستخدمين الذين تلقوا الايدي الخاص. يرجى الاتصال بفريق App. ستحتاج منتجات الايدي الخاصة إلى 7 أيام لإنتاجها
    <br/>5. سيستند نشاط  الشحن إلى وقت المملكة العربية السعودية من الأول من كل شهر إلى الأول من الشهر المقبل
    <br/>6. بعد الحصول على Recharge Stars  لمدة 3 وقت متتالي ، سيكون لديك بشكل دائم
    <br/>7. لها الحق النهائي في هذا النشاط App
    <br/>
    <br/>- قواعد ترقية  الايدي إعادة الشحن الشهرية 
    <br/>1. الوقت الشهري هو الوقت السعودي من الأول من كل شهر إلى الأول من الشهر المقبل
    <br/>2. لا يمكن تحويل الايدي إلى حسابات أخرى
    <br/>3. يمكن تعيين كل الايدي مرة واحدة في الشهر من خلال إعادة الشحن الشهرية 
    <br/>4. يمكن لكل حساب الحصول على الايدي واحد فقط من خلال إعادة الشحن الشهري لكل حساب 
    <br/>5. ارجو تتواصل الايدي: 1 لمعرفه التفاصيل 
    `,
    monthly: 'المكافأت الشهرية',
    get: 'إستلام',
    headwear: 'إطار',
    service: 'بعد اتمام عملية الشحن قم بالتواصل مع الادارة للحصول على معرفك الخاص',
    tipText: 'نشاط الشحن هذا انتهى',
    dayText: 'يوم',
  },
  tr: {
    timeR: 'Kalan süre: ',
    ruleText: 'Kural',
    DailyBenefits: 'Günlük Bonuslar',
    rule: `
    1. Günlük ödüller: Katılımcıların şarjı belirli bir miktara ulaştığında, ekstra jetonları almak için katılımcıların manuel olarak "Al" düğmesini tıklamaları gerekir.<br/>
    2. Aylık ödüller: Katılımcıların şarjı belirli bir miktara ulaştığında, katılımcıların tüm paket hediyesini almak için manuel olarak "AL" düğmesini tıklamaları gerekir.<br/>
    3. Talep edilmeyen eylemler, Katılımcılar ödüllerini kullanamazlarsa ödüllerini kaybedeceklerdir. App, eksik hediyelerden sorumlu olmayacaktır.<br/>
    4. Özel Kimliklerini alan kullanıcılar için. Lütfen App ekibiyle iletişime geçin. Özel Hediyeler yapımlarının üretilmesi 7 güne ihtiyaç duyacaktır.<br/>
    5. Yeniden doldurma etkinliği, her ayın 1'inden sonraki ayın 1'ine kadar TR zamanına dayalı olacaktır.<br/>
    6. Ardışık 3 kez Yeniden Doldurma Yıldızları elde ettikten sonra, ona kalıcı olarak sahip olacaksınız.<br/>
    7. Bu aktivitenin son hakkı App'ye aittir. <br/><br/>
    - Aylık şarj kimliği yükseltme kuralları <br/>
    1. Aylık saat, her ayın 1'inden sonraki ayın 1'ine kadar TR saatidir. <br/>
    2. Kimlik başka hesaplara aktarılamaz. <br/>
    3. Her kimlik, aylık şarj yoluyla ayda bir kez ayarlanabilir. <br/>
    4. Her hesap, aylık şarj ile ayda yalnızca bir kimlik alabilir. <br/>
    5. Daha fazla ayrıntı için ID SELMAN  ile iletişime geçin. <br/>
    `,
    monthly: 'Aylık Bonuslar',
    get: 'Get',
    headwear: 'Headwear',
    service:
      "Yükleme işlemini tamamladıktan sonra özel ID'nizi almak için Yönetim ile iletişime geçiniz.",
    tipText: 'Bu Yükleme etkinliği sona erdi.',
    dayText: 'Gün',
  },
  jp: {
    timeR: 'カウントダウン: ',
    ruleText: 'Rule',
    DailyBenefits: 'Daily Benefits',
    rule: `
    1. デイリー リワード: 参加者のリチャージが特定の金額に達したら、参加者は追加のコインを受け取るために [取得] ボタンを手動でクリックする必要があります。<br/>
    2. 毎月の報酬: 参加者が特定の金額に達した場合、参加者は手動で [GET] ボタンをクリックしてパッケージ ギフト全体を受け取る必要があります。<br/>
    3. 未請求の行動、参加者が賞品を引き換えなかった場合、参加者は賞品を失います。 App は、ギフトの紛失について責任を負いません。<br/>
    4. 特別IDを取得された方へAppチームにお問い合わせください。スペシャル ギフトの制作には 7 日かかります。<br/>
    5. リチャージ アクティビティは、毎月 1 日から翌月 1 日までの KSA 時間に基づきます。<br/>
    6. リチャージ スターを 3 回連続で獲得すると、永久にリチャージ スターを獲得できます。<br/>
    7. App は、この活動の最終的な権利を有します。 <br/><br/>
    - 毎月のリチャージ ID アップグレード規則 <br/>
    1. 月間時間は、毎月 1 日から翌月 1 日までのサウジアラビア時間です。 <br/>
    2. IDを他のアカウントに譲渡することはできません。 <br/>
    3. 各 ID は、毎月のリチャージを通じて月に 1 回設定できます。 <br/>
    4. 各アカウントは、毎月のリチャージを通じて、1 か月に 1 つの ID しか取得できません。 <br/>
    5. 詳細については、ID 1 にお問い合わせください。 <br/>
    `,
    monthly: 'Monthly Benefits',
    get: 'Get',
    headwear: 'Headwear',
    service: 'To get your ID after you done recharge contact ID 2',
    tipText: 'This recharge activity has ended.',
    dayText: 'days',
  },
  pt: {
    timeR: 'Contagem regressiva: ',
    ruleText: 'Regra',
    DailyBenefits: 'Benefícios Diários',
    rule: `
    1. Recompensas diárias: Quando os participantes recarregam uma quantia específica, os participantes devem clicar manualmente no botão "Obter" para receber as moedas extras.<br/>
    2. Recompensas mensais: Quando os participantes atingem o valor específico de recarga, os participantes devem clicar manualmente no botão "OBTER" para receber o pacote completo de presente.<br/>
    3. Ações não reclamadas, os participantes perderão seus prêmios se não resgatarem os prêmios. O aplicativo não será responsável por presentes perdidos.<br/>
    4. Para os usuários que receberam seu ID Especial. Por favor, entre em contato com a equipe do aplicativo. A produção de presentes especiais levará 7 dias para ser produzida.<br/>
    5. A atividade de recarga será baseada no horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do mês seguinte.<br/>
    6. Após obter as Estrelas de Recarga por 3 vezes consecutivas, você as terá permanentemente.<br/>
    7. O aplicativo tem o direito final sobre essa atividade. <br/><br/>
    - Regras de atualização do ID de recarga mensal <br/>
    1. O tempo mensal é o horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do mês seguinte. <br/>
    2. O ID não pode ser transferido para outras contas. <br/>
    3. Cada ID pode ser configurado uma vez por mês através da recarga mensal. <br/>
    4. Cada conta pode obter apenas um ID por mês através da recarga mensal. <br/>
    5. Para mais detalhes, entre em contato com o ID 1. <br/>
    `,
    monthly: 'Benefícios Mensais',
    get: 'Obter',
    headwear: 'Acessórios de cabeça',
    service: 'Para obter seu ID após recarregar, entre em contato com o ID 2',
    tipText: 'Esta atividade de recarga foi encerrada.',
    dayText: 'dias',
  },
  id: {
    timeR: 'Hitung mundur: ',
    ruleText: 'Aturan',
    DailyBenefits: 'Manfaat Harian',
    rule: `
    1. Hadiah harian: Ketika peserta melakukan pengisian ulang mencapai jumlah tertentu, peserta harus mengklik tombol "Dapatkan" secara manual untuk menerima koin tambahan.<br/>
    2. Hadiah bulanan: Ketika peserta melakukan pengisian ulang mencapai jumlah tertentu, peserta harus mengklik tombol "DAPATKAN" secara manual untuk menerima hadiah paket lengkap.<br/>
    3. Tindakan yang tidak diklaim, Peserta akan kehilangan hadiah mereka jika mereka gagal menebus hadiah mereka. Aplikasi tidak bertanggung jawab atas hadiah yang hilang.<br/>
    4. Untuk pengguna yang menerima ID Khusus mereka. Harap hubungi tim Aplikasi. Produksi Hadiah Khusus memerlukan waktu 7 hari untuk diproduksi.<br/>
    5. Aktivitas pengisian ulang akan berdasarkan waktu KSA dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>
    6. Setelah mendapatkan Bintang Pengisian Ulang 3 kali berturut-turut, Anda akan memilikinya secara permanen.<br/>
    7. Aplikasi memiliki hak akhir atas aktivitas ini. <br/><br/>
    - Aturan pembaruan ID pengisian ulang bulanan <br/>
    1. Waktu bulanan adalah waktu Arab Saudi dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya. <br/>
    2. ID tidak dapat dipindahkan ke akun lain. <br/>
    3. Setiap ID dapat diatur satu kali sebulan melalui pengisian ulang bulanan. <br/>
    4. Setiap akun hanya dapat mendapatkan satu ID per bulan melalui pengisian ulang bulanan. <br/>
    5. Untuk detail lebih lanjut hubungi ID 1. <br/>
    `,
    monthly: 'Manfaat Bulanan',
    get: 'Dapatkan',
    headwear: 'Aksesori Kepala',
    service: 'Untuk mendapatkan ID Anda setelah melakukan pengisian ulang, hubungi ID 2',
    tipText: 'Aktivitas pengisian ulang ini telah berakhir.',
    dayText: 'hari',
  },
  uz: {
    timeR: 'Orqaga qaytish: ',
    ruleText: 'Qoidalar',
    DailyBenefits: 'Kunlik Foydalar',
    rule: `
    1. Kunlik mukofotlar: Ishtirokchilar ma'lum bir miqdorda to'lovni amalga oshirganda, ular qo'shimcha tangalarni olish uchun "Olish" tugmasini qo'lda bosishlari kerak.<br/>
    2. Oylik mukofotlar: Ishtirokchilar ma'lum bir miqdorda to'lovni amalga oshirganda, ular butun paket sovg'ani olish uchun "OLISH" tugmasini qo'lda bosishlari kerak.<br/>
    3. Qabul qilinmagan harakatlar, Ishtirokchilar mukofotlarini olishni unutgan taqdirda, ular mukofotlarini yo'qotadilar. Ilova hech qanday yo'qolgan sovg'alar uchun javobgar emas.<br/>
    4. Maxsus ID olgan foydalanuvchilar uchun, Iltimos, ilova jamoasi bilan bog'laning. Maxsus sovg'alar ishlab chiqarish uchun 7 kun kerak.<br/>
    5. To'lov faolligi har oyning 1-kuni va keyingi oyning 1-kuniga qadar KSA vaqtiga asoslanadi.<br/>
    6. 3 marta ketma-ket to'lov yulduzlarini olganingizdan so'ng, uni doimiy saqlaysiz.<br/>
    7. Ilovada ushbu faollikning yakuniy huquqi mavjud.<br/><br/>
    - Oylik to'lov ID yangilash qoidalari<br/>
    1. Oylik vaqt har oyning 1-kunidan keyingi oyni 1-kunigacha Saudiya vaqti bo'yicha hisoblanadi.<br/>
    2. ID boshqa hisoblarga o'tkazib bo'lmaydi.<br/>
    3. Har bir ID faqat oylik to'lov orqali bir marta sozlanishi mumkin.<br/>
    4. Har bir hisob bir oyda faqat bitta ID olishi mumkin.<br/>
    5. Batafsil ma'lumot uchun ID 1 bilan bog'laning.<br/>
    `,
    monthly: 'Oylik Foydalar',
    get: 'Olish',
    headwear: 'Boshlik',
    service: "To'lovni amalga oshirganingizdan so'ng, ID ni olish uchun ID 2 bilan bog'laning",
    tipText: "Ushbu to'lov faolligi yakunlandi.",
    dayText: 'kun',
  },
  ru: {
    timeR: 'Обратный отсчет: ',
    ruleText: 'Правила',
    DailyBenefits: 'Ежедневные бонусы',
    rule: `
    1. Ежедневные награды: Когда участники пополняют баланс на определенную сумму, они должны вручную нажать кнопку "Получить", чтобы получить дополнительные монеты.<br/>
    2. Ежемесячные награды: Когда участники пополняют баланс на определенную сумму, они должны вручную нажать кнопку "ПОЛУЧИТЬ", чтобы получить весь пакет подарков.<br/>
    3. Невостребованные действия: Участники потеряют свои призы, если они не успеют забрать их. Приложение не несет ответственности за пропавшие подарки.<br/>
    4. Для пользователей, получивших свой специальный ID. Пожалуйста, свяжитесь с командой приложения. Производство специальных подарков займет 7 дней.<br/>
    5. Активность пополнения будет действовать по времени KSA с 1 числа каждого месяца по 1 число следующего месяца.<br/>
    6. После получения Звезд пополнения 3 раза подряд, они останутся у вас навсегда.<br/>
    7. Приложение имеет окончательное право на эту активность.<br/><br/>
    - Правила обновления ID при ежемесячном пополнении<br/>
    1. Месячное время — это время Саудовской Аравии с 1 числа каждого месяца по 1 число следующего месяца.<br/>
    2. ID нельзя передавать другим аккаунтам.<br/>
    3. Каждый ID может быть установлен один раз в месяц через ежемесячное пополнение.<br/>
    4. Каждый аккаунт может получить только один ID в месяц через ежемесячное пополнение.<br/>
    5. Для получения дополнительной информации свяжитесь с ID 1.<br/>
    `,
    monthly: 'Ежемесячные бонусы',
    get: 'Получить',
    headwear: 'Головной убор',
    service: 'Чтобы получить ваш ID после пополнения, свяжитесь с ID 2',
    tipText: 'Эта акция пополнения завершена.',
    dayText: 'дней',
  },
  fa: {
    timeR: 'شمارش معکوس: ',
    ruleText: 'قوانین',
    DailyBenefits: 'مزایای روزانه',
    rule: `
    1. جوایز روزانه: زمانی که شرکت کنندگان شارژ به مقدار خاصی برسند، باید به طور دستی روی دکمه "دریافت" کلیک کنند تا سکه های اضافی را دریافت کنند.<br/>
    2. جوایز ماهانه: زمانی که شرکت کنندگان شارژ به مقدار خاصی برسند، باید به طور دستی روی دکمه "دریافت" کلیک کنند تا هدیه بسته کامل را دریافت کنند.<br/>
    3. اعمال غیر قابل ادعا: اگر شرکت کنندگان جوایز خود را دریافت نکنند، جوایز خود را از دست خواهند داد. اپلیکیشن مسئول جوایز گم شده نخواهد بود.<br/>
    4. برای کاربرانی که شناسه ویژه خود را دریافت کرده اند. لطفاً با تیم اپلیکیشن تماس بگیرید. تولید هدایای ویژه 7 روز برای تولید نیاز دارد.<br/>
    5. فعالیت شارژ بر اساس زمان KSA از 1 ام هر ماه تا 1 ام ماه بعد خواهد بود.<br/>
    6. بعد از دریافت 3 بار ستارگان شارژ متوالی، شما آن را به طور دائم خواهید داشت.<br/>
    7. اپلیکیشن حق نهایی در این فعالیت را دارد.<br/><br/>
    - قوانین ارتقاء شناسه شارژ ماهانه<br/>
    1. زمان ماهانه زمان سعودی است از 1 ام هر ماه تا 1 ام ماه بعد.<br/>
    2. شناسه نمی تواند به حساب های دیگر منتقل شود.<br/>
    3. هر شناسه می تواند یک بار در ماه از طریق شارژ ماهانه تنظیم شود.<br/>
    4. هر حساب تنها می تواند یک شناسه در ماه از طریق شارژ ماهانه دریافت کند.<br/>
    5. برای جزئیات بیشتر با شناسه 1 تماس بگیرید.<br/>
    `,
    monthly: 'مزایای ماهانه',
    get: 'دریافت',
    headwear: 'کلاه',
    service: 'برای دریافت شناسه خود پس از انجام شارژ با شناسه 2 تماس بگیرید',
    tipText: 'این فعالیت شارژ به پایان رسیده است.',
    dayText: 'روز',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/rechargenew/lang.js